import { PRODUCTS } from '@app/shared/brand'
import { SiteShell } from '../../ui/SiteShell'
import { WayIn } from '../../ui/WayIn'
import { TERUMAH_NAV } from './product-nav'
import './marketing.css'

/**
 * Terumah's front door, for somebody arriving signed out.
 *
 * One screen: what it is, and the way in. A donor reaches an org's own giving
 * page by its link and never passes through here, so this speaks to whoever
 * runs one — and says no more than the product does.
 */
export function TerumahHomePage({ onLogin }: { onLogin?: () => void }) {
  return (
    <SiteShell nav={TERUMAH_NAV} onLogin={onLogin}>
      <section className="mk-hero">
        <div className="mk-measure mk-hero__inner">
          <p className="mk-label">{PRODUCTS.terumah.name}</p>
          <h1 className="mk-hero__title">
            A page to give on, and the books behind it.
          </h1>
          <p className="mk-hero__lede">
            A giving page and campaigns for a charity, taking cards on its own
            account — every gift recorded as it arrives, acknowledged from that
            record, and counted toward the campaign it was given to.
          </p>
          <div className="mk-hero__actions">
            <WayIn onSignIn={onLogin} />
          </div>
        </div>
      </section>
    </SiteShell>
  )
}
